import getLanguage from "../get-language.js";
import generateSessiondIdIfNotExists from "../generate-sessionid.js";
import {
  hideValidationMessage,
  showValidationMessage,
  emailValidation,
  passwordValidation,capitalLettersValidation,
  smallLettersValidation,numbersValidation,
  

} from "../form-validation-message.js";
import { setDatePickers } from "./rmo/set-date-picker.js"
import { debounceApiWithDelay } from "./rmo/debounce-api.js";
import { triggerAddressApi } from "./rmo/rmo-address-api.js";

(async () => {
  const fullRegistration = document.getElementById("fullRegistration");
  if (fullRegistration) {
    const { lang, country } = getLanguage();
    const languageFromUrl = getLocalLanguage(lang);
    const fullRegistrationLoader = fullRegistration.querySelector(
      "#fullRegistrationLoader"
    );
    const fullRegistrationContainer = fullRegistration.querySelector(
      "#fullRegistrationContainer"
    );

    //query params
    const givenName = getUrlParameter("givenName")?.toUpperCase() || "";
    const surname1 = getUrlParameter("surname1")?.toUpperCase() || "";
    const surname2 = getUrlParameter("surname2")?.toUpperCase() || "";
    const email = getUrlParameter("email")?.includes("WUTEMPMAIL.COM")
      ? ""
      : getUrlParameter("email");
    const phoneNo = getUrlParameter('phone')
    const phoneNoMasked = getUrlParameter("maskedPhoneNumber") || "";
    if(phoneNoMasked){ window.sessionStorage.setItem("trans-wa-masked-phoneno", phoneNoMasked)}
    const externalRefId = getUrlParameter("id");
    let token = getUrlParameter("token") || "";
    const countryCode = getUrlParameter('countryCode')
    token = token?.startsWith("Bearer") ? token : `Bearer ${token}`;
    const receiverCountry = getUrlParameter("receiverCountry")?.toUpperCase();
    const mtcn = getUrlParameter('mtcn')||getUrlParameter('MTCN') || ""
    if(mtcn){  
      window.sessionStorage.setItem("trans-wa-mtcn", mtcn)
    }
    let sessionId;
    let isFormValid ;

    if (externalRefId) {
      window.sessionStorage.setItem("trans-wa-externalRefId", externalRefId);
    }
    window.sessionStorage.setItem("trans-wa-app", {});
        
    const continueRegistration = fullRegistration.querySelector(
      "#continue-registration"
    );

    const emailEl = fullRegistration.querySelector("#input-email-address");
    const passwordEl = fullRegistration.querySelector("#input-password");
    const addressLine1El = fullRegistration.querySelector(
      "#input-address-line-1"
    );
    const addressLine2El = fullRegistration.querySelector(
      "#input-address-line-2"
    );
    const stateEl = fullRegistration.querySelector(".input-state-data");
    const cityEl = fullRegistration.querySelector("#input-city-data");
    const postalEl = fullRegistration.querySelector("#input-postal-data");
    const error500Message = fullRegistration.querySelector("#errorCode_500");
    const errorOtherMessage = fullRegistration.querySelector(".error-other");
    const errorProfileExists = fullRegistration.querySelector(".error-profile-exists");
    const errorSessionTimeOut = fullRegistration.querySelector(".error-sessionTimeOut");
    const errorBanner = fullRegistration.querySelector("#errorBanner")
    const errorCode_C9999 =  fullRegistration.querySelector("#errorCode_C9999");
    let formEle = fullRegistration.querySelectorAll(".formEle"); 
    let err_msg_set = fullRegistration.querySelectorAll(".err-msgs")  
    const dobEl = fullRegistration.querySelector("#input-dob");

    let input_password_error_container = document.getElementById(
      "input_password_error_container"
    );
    let passwordLengthError = fullRegistration.querySelector(
      ".input-password-error_character_limit"
    );
    let lettersCapitalValidationError = fullRegistration.querySelector(
      ".input-password-error_CapsLetters"
    );

    let lettersSmallValidationError = fullRegistration.querySelector(
      ".input-password-error_SmallLetters"
    );

    let numberValidationError = fullRegistration.querySelector(
      ".input-password-error_number"
    );

    let emailNameError = fullRegistration.querySelector(
      ".input-password-email-name"
    );
    
    const eyeIconDisplayPassword = fullRegistration.querySelector(
      ".eye-icon-display-password"
    );
    let dobIconEl = fullRegistration.querySelector(
      "#dob-icon-el"
    );
    let addressLookupEls = fullRegistration.querySelectorAll(".address-lookup");
    const viewEyeIcon = eyeIconDisplayPassword.querySelector(".view-eye-icon");
    const hideEyeIcon = eyeIconDisplayPassword.querySelector(".hide-eye-icon");
    const validationObj = {
      emailEl: "false",
      addressLine1El: "false",
      stateEl: "false",
      postalEl: "false",
      cityEl: "false",
      dobEl: "true",
      passwordEl: "false",
    };

  
    const stateDropdownSection = document.querySelector("#state_dropdown")
    const stateDropdownEle = stateDropdownSection.querySelector('.stateDropdownEle')
    const inputState = stateDropdownSection?.querySelector('.b-flag-select__search-field')
    const inputLabelState =stateDropdownSection?.querySelector('.b-flag-select__value')
    const unorderedListStates = stateDropdownSection?.querySelector('.b-flag-select__list')
    let selectedStateCode = "";
    let stateListMX = []
    let statesInList
    const selectStateError = document.querySelector('#select-state-error')
    dropdownFeature(stateDropdownSection)

    const resetStateValues = () => {
      inputState.innerText = "";
      inputLabelState.innerText = "";
      inputState.value = "";
      inputLabelState.value = "";
      inputState.setAttribute("data-value", "");
      stateEl.setAttribute("value", "");
      selectedStateCode = "";
      searchInStatesFilter("")
      validationObj['stateEl'] = "false";
      validForm['stateEl'] = "false";
    };

    const getMXStates = async()=>{
      try {
      const dcaasUrl = 'https://www.westernunion.com/wuconnect/dcaas/list.optimus.json?dcaasversion=R250940';
      const dcaasPayload = {
        lists: [
          { name: "MX_CITY_LIST", type: "state" },
          { name: "MX_STATE_LIST", type: "state" }
        ],
        origination: "us",
        language: "en",
        path: "/us/en"
      };
      const dcaasHeaders = {
        'accept': 'application/json, text/plain, */*',
        'content-type': 'application/json',
        'accept-language': 'en-US,en;q=0.9',
        'cache-control': 'no-cache',
        'referer': 'https://www.westernunion.com/us/en/web/send-money/start',
      };
      // fetchApiWu(url, options, methodName, showLoader, showError)
      const stateList = await fetchApiWu(
        dcaasUrl,
        {
          method: 'POST',
          headers: dcaasHeaders,
          body: JSON.stringify(dcaasPayload)
        },
        'dcaas-list-optimus',
        false,
        false
      );
      if (stateList) {
       
        stateListMX = Object.entries(stateList['MX_STATE_LIST']).map((a)=>{return {stateCode: a[0],stateValue : a[1]}})
        let fragment = document.createDocumentFragment();
        stateListMX?.forEach(({ stateCode, stateValue }) => {
          addLiToListStates(stateCode, stateValue, fragment);
        });
        unorderedListStates?.append(fragment)
        statesInList = unorderedListStates?.querySelectorAll("li");
        statesInList?.forEach((li) => {
          li.addEventListener("click", (e) => {
            e.stopPropagation();
            inputState.innerText =  e.target.getAttribute('data-text')
            inputLabelState.innerText = e.target.getAttribute('data-text')
            inputState.value =  e.target.getAttribute('data-text')
            inputLabelState.value = e.target.getAttribute('data-value')
            inputState.setAttribute('data-value',e.target.getAttribute('data-value'))
            stateEl.setAttribute('value',e.target.getAttribute('data-value')) 
            selectedStateCode =e.target.getAttribute('data-value');
            stateDropdownEle.classList.remove('wuds-dropdown--active')
            toggleDropdown(true, unorderedListStates)
            validationObj['stateEl'] = "true";
            validForm['stateEl'] = "true";
            hideValidationMessage(stateEl);
          });
        });
         
      } else console.log("Error in fetching List");
     
    } catch (err) {
      console.error('Error calling dcaas list.optimus.json:', err);
    }
    }
    
   getMXStates();
  
    const addLiToListStates = (stateCode, stateValue,fragment) => {
        let li = document.createElement('li');
        li.className = 'wuds-dropdown__items b-flag-select__item pad-8-lt';
        li.setAttribute('data-text', stateValue)
        li.setAttribute('data-value', stateCode)
        li.innerText = stateValue
        fragment.append(li)
    }
    
    inputState?.addEventListener('click', (e) => {
        e.stopPropagation();
    })

    inputState?.addEventListener("input", (e) => {
      e.stopPropagation();
      resetStateValues();
      inputLabelState.innerText = e.target.value
      if(stateEl.getAttribute('value')!== "" && selectedStateCode!== ""){
        validForm['stateEl'] = "true";
        hideValidationMessage(stateEl);
      }
      else{
        validForm['stateEl'] = "false";
        showValidationMessage(stateEl);
      }
      searchInStatesFilter(e.target.value)
      toggleDropdown(false, unorderedListStates)
      
    });

    inputState?.addEventListener("blur", (e) => {
      e.stopPropagation();
      if(stateEl.getAttribute('value')!== "" && selectedStateCode!== ""){
        validForm['stateEl'] = "true";
        hideValidationMessage(stateEl);
      }
      else{
        validForm['stateEl'] = "false";
        showValidationMessage(stateEl);
      }
     
    });
    const searchInStatesFilter = (val) => {
            Array.prototype.slice.call(statesInList).forEach(item => {
                let parsedText = item?.innerText?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                let parsedValue = val?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                if((!val) || (parsedText && val && parsedValue && (parsedText.toLowerCase().indexOf(parsedValue.toLowerCase()) !== -1 || item?.innerText.toLowerCase().indexOf(val?.toLowerCase()) !== -1))) {
                    item?.classList.remove('d-none')
                    item?.classList.add('d-flex')
                } else {
                    item?.classList.add('d-none')
                    item?.classList.remove('d-flex')
                }
            })
        }

    sessionId = await generateSessiondIdIfNotExists(sessionId,receiverCountry,languageFromUrl );
    CookieService.setCookie('SessionId', sessionId, 30, '/', true, ".westernunion.com");
    window.sessionStorage.setItem('trans-wa-sessionId',sessionId)
    // ---------------- Form Validations -----------------------

    setDatePickers(dobEl);
    dobEl.addEventListener('focus', (e) => {
      validationObj['dobEl'] = !!e.target.value;
    })

     const toggleDropdown = (closeDropdown, dropdownElem) => {
       if (closeDropdown) {
         toggleClass(dropdownElem, "d-block", "d-none");
         return;
       }
       if (dropdownElem.classList.contains("d-none")) {
         toggleClass(dropdownElem, "d-none", "d-block");
       } else {
         toggleClass(dropdownElem, "d-block", "d-none");
       }
     };
    

    const validForm = new Proxy(
      {},
      {
        set: function (target, property, value) {
          let isValid = true;
          validationObj[property] = value;
          for (const [key, value] of Object.entries(validationObj)) {
            if (value == "false") {
              isValid = false;
              isFormValid = false;
              continueRegistration.setAttribute("disabled", true);
              break;
            }
          }
          if (isValid) {
            isFormValid = true;
            continueRegistration.removeAttribute("disabled");
          }
          return target;
        },
      }
    );

    addressLine2El.addEventListener('input',(e)=>{
      e.target.setAttribute("value",e.target.value)
    })

    const focusInputOnDobClick = (dobIconEl) => {
      dobIconEl.addEventListener("click", (e) => {
        e.preventDefault();
        e.target.closest(".wu-input--bordered").querySelector("input").focus();
      });
    };

    focusInputOnDobClick(dobIconEl);

    eyeIconDisplayPassword?.addEventListener("click", (event) => {
      const typeOfErrorInput = passwordEl.getAttribute("type");
      if (typeOfErrorInput === "text") {
        passwordEl?.setAttribute("type", "password");
        toggleClass(hideEyeIcon, "d-inline", "d-none");
        toggleClass(viewEyeIcon, "d-none", "d-inline");
      } else {
        passwordEl?.setAttribute("type", "text");
        toggleClass(hideEyeIcon, "d-none", "d-inline");
        toggleClass(viewEyeIcon, "d-inline", "d-none");
      }
    });
 
    const errorBasedEventListener = (element, errorField) => {

      if(dobEl.getAttribute('value')!== "" && dobEl.getAttribute('value').length!=0){
         validForm['dobEl'] = "true";
      }
      else{
        validForm['dobEl'] = "false";
      }

      if(stateEl.getAttribute('value')!== "" && selectedStateCode!== ""){
        validForm['stateEl'] = "true";
        hideValidationMessage(stateEl);
      }
      else{
        validForm['stateEl'] = "false";
        showValidationMessage(stateEl);
      }

      element.addEventListener("blur", (e) => {
        if (
          (errorField !== "dobEl" && !e.target.value) ||
          (errorField === "dobEl" && !e.target.getAttribute("value"))
        ) {
          showValidationMessage(e.target);
        } else if((e.target.id === 'input-password' && !passwordValidation(e.target)) ||
                  (e.target.id === 'input-email-address' && !emailValidation(e.target))
        ) {
          showValidationMessage(e.target);
        } else {
          hideValidationMessage(e.target);
        }
      });


      element.addEventListener("input", debounceGeneric((e) => {
        e.target.setAttribute("value", e.target.value);
        if (!e.target.value) {
          validForm[errorField] = "false";
          showValidationMessage(e.target);
         
        } else if (
          element == emailEl && !emailValidation(e.target) || element == passwordEl && !passwordValidation(e.target) || element == postalEl &&  e.target.value.length >=2 && e.target.length< 10
        )
        {
          validForm[errorField] = "false";
          showValidationMessage(e.target);
        }
        else {
          validForm[errorField] = "true";
          hideValidationMessage(e.target);
        }
      },1000)
    );


    };

    let validationArr = [
      [addressLine1El, "addressLine1El"],
      [stateEl, "stateEl"],
      [postalEl, "postalEl"],
      [cityEl, "cityEl"],
      [dobEl, "dobEl"],
      [emailEl, "emailEl"],
      [passwordEl, "passwordEl"],
    ];


    validationArr.forEach(([el, errorField]) => {
      if (el === dobEl && dobEl.value !== "") {
        validForm.dobEl = "true";
      }
      if(el === stateEl && selectedStateCode!== "" && stateEl.value !=""){
        validForm.stateEl = "true"; 
      }
      else{
          validForm.stateEl = "false";
      }
      errorBasedEventListener(el, errorField);
    });
    
    const showErrorForElements = () => {
      validationArr.forEach(([el, errorField]) => {
        if (!el.value) {
          validForm[errorField] = "false";
          showValidationMessage(el);
        } else {
          validForm[errorField] = "true";
          hideValidationMessage(el);
        }
      });
    };

    postalEl.addEventListener("input", (e) => {
      e.target.setAttribute("value", e.target.value);
      let postval = e.target.value.length
        if (postval<=2 || postval > 10) {
          showValidationMessage(e.target);
        } else {
          hideValidationMessage(e.target);
        }
    });

    emailEl.value = email && email.includes("WUTEMPMAIL.COM") ? "" : email;

    passwordEl.onfocus = (e)=> {
      toggleClass( input_password_error_container, "d-none", "d-block"); 
     
    }
    passwordEl.onblur = (e)=> {
      toggleClass( input_password_error_container, "d-block", "d-none");  
    }

    passwordEl.addEventListener("input", (e) => {
      e.target.setAttribute("value", e.target.value);
      let pwdValue = e.target.value

      if(pwdValue.length >= 8 && pwdValue.length<=16) {
        toggleClass(passwordLengthError, "text-alert-dark", "text-success-light");
      }
      else {
        toggleClass(passwordLengthError, "text-success-light", "text-alert-dark");
      }
      capitalLettersValidation(e.target) ? toggleClass(lettersCapitalValidationError, "text-alert-dark", "text-success-light"):  toggleClass(lettersCapitalValidationError, "text-success-light", "text-alert-dark");
      smallLettersValidation(e.target) ? toggleClass(lettersSmallValidationError, "text-alert-dark", "text-success-light"):  toggleClass(lettersSmallValidationError, "text-success-light", "text-alert-dark");
      numbersValidation(e.target) ? toggleClass(numberValidationError, "text-alert-dark", "text-success-light"):  toggleClass(numberValidationError, "text-success-light", "text-alert-dark");
      let emailUsernameValue = emailEl.value.toLowerCase().split("@")[0];
      let enameErrFlag = false;
      let pwdHasNameEmail = !!([ givenName, surname1, emailUsernameValue].find((text) => pwdValue?.toLowerCase().includes(text.toLowerCase()) ))
      if (pwdHasNameEmail || !pwdValue) {
        enameErrFlag = true;
      } else {
        enameErrFlag = false;
        toggleClass(emailNameError, "text-alert-dark", "text-success-light");
      }
      enameErrFlag
        ? toggleClass(emailNameError, "text-success-light", "text-alert-dark")
        : toggleClass(emailNameError, "text-alert-dark", "text-success-light");

      if (!passwordValidation(e.target) && !enameErrFlag) {
        showValidationMessage(e.target);
      } else {
        hideValidationMessage(e.target);
      }
    });

    const hidefullRegistrationLoader = () => {
      toggleClass(fullRegistrationLoader, "d-flex", "d-none");
      toggleClass(fullRegistrationContainer, "d-none", "d-flex");
      if(fullRegistration.querySelector(".stateDropdownEle").classList.contains('wu-input--error')){
        hideValidationMessage(stateEl);
      }
    };


    formEle.forEach((ele) => {
      ele.addEventListener("click", (e) => {
        if (err_msg_set) {
          err_msg_set.forEach((n) => {
            n.classList.remove("d-flex");
            n.classList.remove("d-block");
            n.classList.add("d-none");
          });
        }
      });
    });
    
    const triggerVerifyUserAPI = async () => {
  
      let checkUserStatus = await window.queryData.triggerVerifyUser(
        receiverCountry,
        languageFromUrl,
        sessionId,
        externalRefId,
        emailEl.value
      );
      if (checkUserStatus.status === "USER_NOT_FOUND") {
        const userRegistered = await triggerRegisterUser();
      } else if (checkUserStatus.errorCode) {
        showErrorOrThanxScreen(checkUserStatus);
      } else {
        showErrorBanner("other");
      }
      
    };

    const triggerRegisterUser = async () => {
    
      let dobSplit = dobEl.value.split('/')
      let dobReArranged = `${dobSplit[2]}-${dobSplit[1]}-${dobSplit[0]}`
    const customerRequestBody = {
      customer: {
        name: {
          givenName: givenName||"" ,
          paternal: surname1 || "",
          maternal: surname2 || "",
        },
        address: {
          addressLine1: addressLine1El.value,
          addressLine2: addressLine2El.value,
          city: cityEl.value,
          countryCode: receiverCountry,
          stateCode: selectedStateCode,
          postalCode: postalEl.value,
        },
        countryOfBirth: receiverCountry,
        nationality: receiverCountry,
        dateOfBirth: dobReArranged,
        phoneNumber: [
          {
            type: "CELL_PHONE",
            countryCode: countryCode || "51",
            number: phoneNo || "",
          },
        ],
        credential: {
          password: passwordEl.value,
        },
        notification: {
          optInWhatsApp: true,
          prefLanguageCode: languageFromUrl,
        },
        email: emailEl.value
      },
      mfaType : "EMAIL"
    };  
      
      try {
        window.sessionStorage.setItem(
          "trans-wa-app",
          JSON.stringify(customerRequestBody)
        );
        const customerResponse = await window.queryData.triggerUserRegistration(
          receiverCountry,
          languageFromUrl,
          sessionId,
          externalRefId,
          customerRequestBody
        );

        if (customerResponse) {
          //MFA Error
           if (customerResponse.error.errorCode === "C5008") {
            let stateToken = customerResponse.stateToken
              ? customerResponse.stateToken
              : "";
            window.sessionStorage.setItem("trans-wa-stateToken", stateToken);
            window.location.href = `/global/` + lang + `/send-otp.html`;
          } else if (customerResponse) {
            showErrorOrThanxScreen(customerResponse);
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    const showErrorBanner =(errorCode)=>{
      toggleClass(errorBanner, "d-none", "d-flex");
      errorBanner.focus();
      errorBanner.scrollIntoView({behavior:"smooth",block:"start"})
      
      if (errorCode === "C1052") {
        toggleClass(errorProfileExists, "d-none", "d-flex");
      } else if (errorCode === "C5000") {
        toggleClass(errorSessionTimeOut, "d-none", "d-flex");
      }else if (errorCode === "C9999" || errorCode === "auth99" || errorCode === "C6003") {
        toggleClass(errorCode_C9999, "d-none", "d-flex");
      }else if (errorCode === "500"){
         toggleClass(error500Message, "d-none", "d-flex");
      }
      else if(errorCode === 'other'){
         toggleClass(errorOtherMessage, "d-none", "d-flex");
      }
    }
    
    const showErrorOrThanxScreen = (response) => {
      if (response.error) {
        continueRegistration.setAttribute("disabled", true);
      }
      if (response.ok === false && response.status === 500) {
        showErrorBanner("500");
      }
      else if (response?.errorCode) {
        let ermsg = response.message ? response.message : response.errorMessage
        errorOtherMessage.innerHTML = ermsg;
        showErrorBanner("other");
      } else if (response.error.errorCode){
        let ermsg = response.error.message ? response.error.message : response.error.errorMessage
        errorOtherMessage.innerHTML = ermsg;
        showErrorBanner("other");
      }
      else {
        //Fallback UI
          hidefullRegistrationLoader();
          showErrorBanner("C9999");
      }

    };
    
    continueRegistration.addEventListener("click", (e) => {
      if(Object.values(validForm).every(Boolean)){
           triggerVerifyUserAPI();
      }
      else showErrorForElements();
    });

    // Check the Flow for Full registration or Update User 
    if (receiverCountry && phoneNo) {
      hidefullRegistrationLoader();
    } else {
      showErrorOrThanxScreen({ ok: false, wrongParams: true });
    }

      const debouncedFunction = async (
        addressLookupUl,
        addressLookupEl,
        AkCountry
      ) => {
        const dataAddressApi = await triggerAddressApi(AkCountry, addressLookupEl);
        const fragment = document.createDocumentFragment();
        resetStateValues();
       
        for (let data of (dataAddressApi.address || [])) {
          addLiTounorderedList(
            data.rawAddress.replace(/"/g, ""),
            JSON.stringify(data),
            fragment
          );
        }
        addressLookupUl.append(fragment);
        addressLookupUl.classList.remove("d-none");
        addressLookupUl.classList.add("d-block");
        const lis = addressLookupUl.querySelectorAll("li");
        Array.from(lis).forEach((li) => {
          li.addEventListener("click", (e) => {
            e.preventDefault();
              let addressContainer = document.querySelector(
                "#addressContainer"
              );
              let dataValueChange = JSON.parse(li.getAttribute("data-value"));
              let addressVal = addressContainer.querySelector('[class*="address-lookup-addr1"]');
              let cityVal = addressContainer.querySelector('[class*="address-lookup-city"]');
              let postalVal = addressContainer.querySelector(
                '[class*="address-lookup-zip"]'
              );
              let stateInputData = addressContainer.querySelector(
                '[class*="input-state-data"]'
              );
    
              if (addressVal) {
                addressVal.setAttribute("value", dataValueChange["addressLine1"]);
                addressVal.value = dataValueChange["addressLine1"];
                validationObj['addressLine1El'] =true;
                hideValidationMessage(addressVal);
              }
            
              if (cityVal) {
                cityVal.setAttribute("value", dataValueChange["city"]);
                cityVal.value = dataValueChange["city"];
                validationObj['cityEl'] =true;
                hideValidationMessage(cityVal);
              }
      
              if (stateInputData) {
                let stateObj = stateListMX.find(item => item.stateValue === dataValueChange["stateCode"]);
                if( !stateObj || Object.keys(stateObj).length === 0 )
                { 
                  validationObj['stateEl'] = "false";
                  validForm['stateEl'] = "false";
                  showValidationMessage(stateEl);
                 }
                else{

                  inputState.innerText =  stateObj.stateValue
                  inputLabelState.innerText = stateObj.stateValue
                  inputState.value =  stateObj.stateValue
                  inputLabelState.value = stateObj.stateValue
                  inputState.setAttribute('data-value',stateObj.stateCode)
                  stateEl.setAttribute('value',stateObj.stateCode) 
                  selectedStateCode =stateObj.stateCode;
                  validationObj['stateEl'] ="true";
                  validForm['stateEl'] = "true";
                  hideValidationMessage(stateEl);
                }
            
              }
            addressLookupUl.innerHTML = "";
          });
        });
      };

    Array.from(addressLookupEls).forEach((addressLookupEl) => {
        const addressLookupUl = addressLookupEl.parentElement.querySelector(
          "ul.address-lookup-ul"
        );
        let timer = {data: null};
        if(addressLookupUl) {
          addressLookupEl.addEventListener("keydown", async (e) => {
            if(receiverCountry){
              const debouncedApi = await debounceApiWithDelay(debouncedFunction, 100, timer);
              await debouncedApi(addressLookupUl, addressLookupEl, receiverCountry);
            }    
          });
        
          addressLookupEl.addEventListener("blur", () => {
            addressLookupUl?.setAttribute('style', 'border-bottom: 0px')
            setTimeout(() => {
              addressLookupUl?.classList.add("d-none");
              addressLookupUl?.classList.remove("d-block");
              addressLookupUl?.removeAttribute("style");
            }, 400);
          });
        }
      });
   
  }
})();